{
  "tabs": {
    "chat": "Chat",
    "reminders": "Mementouri",
    "calendar": "Calendar",
    "settings": "Setări"
  },
  "common": {
    "cancel": "Anulează",
    "save": "Salvează",
    "confirm": "Confirmă",
    "delete": "Șterge",
    "back": "Înapoi",
    "close": "Închide",
    "edit": "Editează",
    "search": "Caută",
    "all": "Toate",
    "loading": "Se încarcă...",
    "error": "Ceva nu a mers bine",
    "notFound": "Nu a fost găsit",
    "tryAgain": "Te rog încearcă din nou",
    "retry": "Reîncearcă",
    "undo": "Anulează",
    "pullToRefresh": "Trage pentru reîmprospătare",
    "justNow": "chiar acum"
  },
  "auth": {
    "welcome": "Bine ai venit la FishMemory",
    "tagline": "Asistentul tău de mementouri WhatsApp, acum în buzunar.",
    "subtitle": "Asistentul tău de mementouri WhatsApp, acum în buzunar.",
    "phoneLabel": "Numărul tău WhatsApp",
    "phoneHint": "Îți vom trimite un cod de verificare prin WhatsApp",
    "invalidPhone": "Te rog introdu un număr de telefon valid",
    "continue": "Continuă",
    "enterPhone": "Introdu numărul tău WhatsApp",
    "phonePlaceholder": "Număr de telefon",
    "sendCode": "Trimite cod",
    "verifyTitle": "Verifică numărul tău",
    "otpSentTo": "Un cod de 6 cifre a fost trimis la {{phone}} prin WhatsApp",
    "enterFullCode": "Te rog introdu toate cele 6 cifre",
    "invalidOtp": "Cod invalid. Te rog încearcă din nou.",
    "otpFailed": "Trimiterea codului a eșuat. Încearcă din nou.",
    "otpResent": "Cod retrimis",
    "resendIn": "Retrimite în {{seconds}}s",
    "resendCode": "Retrimite cod",
    "enterOtp": "Introdu codul trimis pe WhatsApp",
    "verify": "Verifică",
    "resend": "Retrimite cod",
    "wrongNumber": "Număr greșit?",
    "backToPhone": "Înapoi la telefon",
    "editPhone": "Editează numărul",
    "error": "Eroare",
    "setupTitle": "Hai să configurăm",
    "setupSubtitle": "Poți schimba oricând în Setări",
    "namePlaceholder": "Numele tău",
    "letsGo": "Finalizează configurarea",
    "skipForNow": "Sari peste acum"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Scrie un mesaj...",
    "inputPlaceholder": "Scrie un mesaj...",
    "typing": "FishMemory scrie...",
    "online": "Online",
    "connecting": "Se conectează...",
    "reconnecting": "Se reconectează...",
    "offline": "Offline",
    "empty": "Începe o conversație",
    "emptyHint": "Creează mementouri, verifică programul sau cere ajutor.",
    "emptyAction": "Trimite un memento exemplu",
    "actions": "Acțiuni chat",
    "keep": "Păstrează mesajele",
    "clearTitle": "Șterge chat",
    "clearConfirm": "Ștergi toate mesajele de pe acest dispozitiv? Aceasta nu poate fi anulată.",
    "clear": "Șterge chat",
    "optionSelected": "Selectat: {{label}}",
    "sendingSelection": "Se trimite...",
    "connectionLost": "Se reconectează..."
  },
  "reminders": {
    "title": "Mementourile mele",
    "active": "Active",
    "today": "Astăzi",
    "thisWeek": "Săptămâna aceasta",
    "history": "Istoric",
    "items": "elemente",
    "emptyTitle": "Niciun memento încă",
    "emptySubtitle": "Creează unul din chat și va apărea aici.",
    "emptyAction": "Deschide chat",
    "filterActive": "Active",
    "filterToday": "Astăzi",
    "filterWeek": "Săptămâna aceasta",
    "filterHistory": "Istoric",
    "emptyState": "Niciun memento încă. Începe să scrii!",
    "swipeDone": "Finalizat",
    "swipeSnooze": "Amână",
    "swipeDelete": "Șterge",
    "search": "Caută mementouri...",
    "upcoming": "Următoare",
    "completed": "Finalizate",
    "overdue": "Depășite",
    "tomorrow": "Mâine",
    "synced": "Sincronizat {{value}}",
    "swipeHint": "Glisează un memento pentru mai multe acțiuni",
    "noResults": "Niciun memento nu corespunde căutării",
    "noResultsHint": "Încearcă un alt cuvânt sau șterge căutarea",
    "deleteAllFailed": "Ștergerea tuturor mementourilor a eșuat"
  },
  "calendar": {
    "title": "Calendar",
    "today": "Astăzi",
    "tomorrow": "Mâine",
    "completed": "finalizat",
    "noEvents": "Nimic programat",
    "noEventsSubtitle": "Alege o dată pentru a vedea mementouri și evenimente.",
    "googleEvent": "Google Calendar",
    "legendActive": "Active",
    "legendRecurring": "Recurente",
    "legendDone": "Finalizate",
    "legendGoogle": "Google",
    "previousMonth": "Luna trecută",
    "nextMonth": "Luna următoare",
    "previousYear": "Anul trecut",
    "nextYear": "Anul următor",
    "goToToday": "Mergi la azi",
    "all": "Toate",
    "active": "Active",
    "done": "Finalizate",
    "paused": "Pauză"
  },
  "settings": {
    "title": "Setări",
    "profile": "Profil",
    "name": "Nume afișat",
    "enterName": "Introdu numele tău",
    "language": "Limba",
    "uiLanguage": "Limba aplicației",
    "uiLanguageHelp": "Schimbă interfața, etichetele calendarului și direcția pe acest dispozitiv.",
    "serverLanguage": "Limba chatului",
    "serverLanguageHelp": "Schimbă limba răspunsurilor serverului și a mesajelor de memento pentru contul tău.",
    "timezone": "Fus orar",
    "currentTimezone": "Fus orar curent",
    "timezoneHelp": "Toate orele mementourilor sunt afișate în acest fus orar.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Salvează fusul orar",
    "timezoneSaved": "Fus orar actualizat",
    "detect": "Detectează",
    "detectFailed": "Nu s-a putut detecta fusul orar",
    "autoDetect": "Detectare automată GPS",
    "notifications": "Notificări",
    "notificationsHelp": "Mementourile repetate controlează alertele după livrarea memento-ului. Permisiunile notificărilor se gestionează în setările telefonului.",
    "pushEnabled": "Notificări Push",
    "autoDoneOnFire": "Marchează automat ca finalizat la declanșare",
    "autoDoneOnFireDesc": "Când este oprit, mementourile rămân active până le marchezi finalizate.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Conectat",
    "googleDisconnected": "Deconectat",
    "googleConnectedHelp": "Mementourile noi pot fi sincronizate automat cu calendarul tău.",
    "googleDisconnectedHelp": "Conectează Google Calendar pentru a sincroniza mementourile și evenimentele.",
    "googleConnectFailed": "Conectarea la Google Calendar a eșuat",
    "connected": "Conectat",
    "disconnected": "Deconectat",
    "connect": "Conectează",
    "disconnect": "Deconectează",
    "autoSync": "Sincronizare automată mementouri noi",
    "autosync": "Sincronizare automată mementouri noi",
    "subscription": "Abonament",
    "trialUsed": "Trial: {{used}}/{{total}} folosit",
    "trialStatus": "Trial disponibil",
    "activeStatus": "Abonament activ",
    "expiredStatus": "Abonament expirat",
    "unsubscribedStatus": "Fără abonament",
    "about": "Despre",
    "version": "Versiune",
    "logout": "Deconectare",
    "logoutTitle": "Deconectare",
    "logoutConfirm": "Ești sigur că vrei să te deconectezi?",
    "noName": "Niciun nume setat",
    "serverConnection": "Conexiune server",
    "serverUrl": "URL server",
    "serverEdit": "Editează",
    "saveReconnect": "Salvează și reconectează",
    "resetDefault": "Resetează implicit",
    "invalidServerUrlTitle": "URL server invalid",
    "invalidServerUrlMessage": "Introdu un URL valid http sau https, de ex. https://example.com",
    "uiLanguageChangeFailed": "Schimbarea limbii aplicației a eșuat. Te rog încearcă din nou.",
    "serverLanguageChangeFailed": "Schimbarea limbii chatului a eșuat. Te rog încearcă din nou.",
    "timezoneChangeFailed": "Schimbarea fusului orar a eșuat. Te rog încearcă din nou.",
    "autoSyncChangeFailed": "Actualizarea sincronizării automate a eșuat. Te rog încearcă din nou.",
    "nameChangeFailed": "Actualizarea numelui afișat a eșuat. Te rog încearcă din nou.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalii memento",
    "editTime": "Editează ora",
    "rename": "Redenumește",
    "snooze": "Amână",
    "snooze15": "Amână 15 minute",
    "pause": "Pauză",
    "pauseReminder": "Pauză memento",
    "resume": "Continuă",
    "resumeReminder": "Continuă memento",
    "skip": "Sari următorul",
    "skipOccurrence": "Sari această apariție",
    "syncGoogle": "Sincronizează cu Google",
    "delete": "Șterge",
    "deleteTitle": "Șterge memento",
    "deleteConfirm": "Acest memento va fi șters definitiv.",
    "deleteRecurringTitle": "Șterge memento recurent",
    "deleteRecurringMessage": "Vrei să sari această apariție sau să ștergi întreaga serie?",
    "deleteThisOccurrence": "Sari această apariție",
    "deleteEntireSeries": "Șterge întreaga serie",
    "done": "Finalizat",
    "markDone": "Marchează ca finalizat",
    "undo": "Restabilește",
    "undoPrompt": "Ai nevoie să fie activ din nou? Restabilește-l acum.",
    "recurring": "Recurent",
    "nextRun": "Următoarea rulare",
    "oneTime": "O singură dată",
    "pending": "În așteptare",
    "sent": "Trimis",
    "paused": "Pauză",
    "active": "Activ",
    "snoozed": "Amânat",
    "localTime": "Afișat în ora locală",
    "recurrence": "Recurență",
    "created": "Creat",
    "tags": "Etichete",
    "fireCount": "Număr declanșări",
    "actions": "Acțiuni",
    "none": "Niciunul",
    "snoozeFailed": "Amânarea memento-ului a eșuat",
    "pauseFailed": "Pauza memento-ului a eșuat",
    "resumeFailed": "Reluarea memento-ului a eșuat",
    "skipFailed": "Sărirea memento-ului a eșuat",
    "doneFailed": "Marcarea memento-ului ca finalizat a eșuat",
    "undoFailed": "Restabilirea statusului memento-ului a eșuat",
    "deleteFailed": "Ștergerea memento-ului a eșuat",
    "rescheduleTitle": "Reprogramare?",
    "rescheduleMsg": "Acest memento este depășit. Vrei să îl reprogramezi?",
    "reschedule15": "Peste 15 minute",
    "reschedule60": "Peste 1 oră",
    "keepOverdue": "Păstrează așa"
  },
  "onboarding": {
    "slide1Title": "Bine ai venit la FishMemory",
    "slide1Sub": "Asistentul tău personal de mementouri — alimentat de WhatsApp și făcut pentru buzunarul tău.",
    "slide2Title": "Doar scrie natural",
    "slide2Sub": "Tastează mementouri așa cum gândești: „Amintește-mi să sun mama mâine la 15:00” — noi ne ocupăm de restul.",
    "slide3Title": "Nu rata nimic",
    "slide3Sub": "Primește notificări la timp, organizează cu etichete și fii mereu la curent cu ce contează.",
    "getStarted": "Începe",
    "next": "Următorul",
    "firstReminderTitle": "Creează primul tău memento!",
    "firstReminderHint": "Încearcă să tastezi ceva de genul:",
    "firstReminderExample": "Amintește-mi să beau apă mâine la 9 AM",
    "gotIt": "Am înțeles!",
    "notifRationaleTitle": "Fii punctual",
    "notifRationaleBody": "FishMemory are nevoie de notificări pentru a te reaminti la timp. Vei primi alerte doar pentru mementourile create.",
    "notifRationaleAllow": "Activează notificările",
    "notifRationaleLater": "Poate mai târziu",
    "swipeHint": "Glisează spre dreapta pentru acțiuni rapide →",
    "calendarDragHint": "Trage pentru a extinde ↕"
  }
}
